import React from 'react';
import { useUser } from '@lore/auth';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Form from './Form';
import { Helmet } from 'react-helmet-async';
import useRouter from '../../../hooks/useRouter';
import useSetupNavigation from '../useSetupNavigation';

export default function Layout(props) {
  const { history } = useRouter();

  const user = useUser();

  const navigation = useSetupNavigation(Urls.ZIP_CODE);

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - ZIP Code</title>
      </Helmet>
      <Form
        user={user}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls.NAME_CONTACT)}
        onNext={(newData) => history.push(Urls.EDUCATOR_INTENT_SCHOOL)}
        onSkip={() => history.push(Urls.EDUCATOR_INTENT_SCHOOL)}
      />
    </ParentLayout>
  );
};
